import React from "react";
import Button from "../componentLibrary/Button";
import ToolboxIcon from "../assets/icons/Toolbox.svg";

interface GoToToolboxButtonProps {
  onClick: () => void;
  className?: string;
  size?: "xs" | "sm" | "md" | "lg";
  variant?:
    | "primary"
    | "secondary"
    | "default"
    | "alternative"
    | "dark"
    | "cautionary";
  children?: React.ReactNode;
  roundedFull?: boolean;
  iconSize?: string;
}

const GoToToolboxButton: React.FC<GoToToolboxButtonProps> = ({
  onClick,
  className = "",
  size = "md",
  variant = "secondary",
  children = "Go To Toolbox",
  roundedFull = true,
  iconSize = "w-6 h-6",
}) => {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      className={`!h-10 flex items-center gap-2 px-6 ${className}`}
      size={size}
      roundedFull={roundedFull}
    >
      <img src={ToolboxIcon} alt="" className={iconSize} />
      {children}
    </Button>
  );
};

export default GoToToolboxButton;
